export var BOARD_TRANSLATIONS = {
    board: {
        header: {
            title: {
                default: 'Faça as configurações a seguir para ativar sua loja',
                completed: 'Tudo pronto, aguarde a aprovação',
                approve: 'Pronto, boas-vindas à Rappi',
                error: 'Corrija o erro para que possamos continuar com o processo',
                medium: 'Falta pouco para de ativar sua loja e venda na Rappi!',
                defaultMobile: 'Configure para ativar sua loja',
                completedMobile: 'Tudo pronto, aguarde a aprovação',
                approveMobile: 'Aprovado! Faça sua primeira venda',
                errorMobile: 'Corrija o erro para que possamos continuar com o processo',
                mediumMobile: 'Falta pouco para de ativar sua loja e venda na Rappi!',
            },
            subtitle: {
                default: 'Adicione as informações abaixo para concluir o processo de aprovação do seu restaurante',
                completed: 'Conclua todas as etapas abaixo e continue com o processo de aprovação.',
                approve: 'Tudo pronto! Aproveite a Rappi!',
                medium: 'Termine de adicionar as informações para continuar com o processo de aprovação',
                defaultMobile: 'Conclua todas as etapas do processo de aprovação.',
                completedMobile: 'Conclua todas as etapas do processo de aprovação.',
                approveMobile: 'Tudo pronto! Aproveite a Rappi!',
                mediumMobile: 'Termine de adicionar as informações',
            },
        },
        board: {
            title: {
                open: 'Aguardando preenchimento',
                processing: 'Em revisão',
                error: 'Recusado',
                valid: 'Aprovado',
                completed: 'Concluído',
                locked: 'Aguardando preenchimento',
                validAndLocked: 'Aprovado',
                processingAndLocked: 'Em revisão',
                processingWithIA: 'Em curso',
                processingWithIAAndLocked: 'Em curso',
                generatedWithIA: 'Gerado',
            },
            buttons: {
                open: 'Preencher',
                processing: 'Revisar',
                valid: 'Revisar',
                completed: 'Revisar',
                error: 'Ver motivo',
                locked: 'Preencher',
                validAndLocked: 'Revisar',
                processingAndLocked: 'Revisar',
                processingWithIA: 'Revisar',
                processingWithIAAndLocked: 'Revisar',
                generatedWithIA: 'Configurar',
            },
        },
        modal: {
            subtitle: 'Motivo de recusa',
            body: {
                nextStep: 'Próximos passos',
                description: 'Siga as etapas anteriores para dados que falharam. Clique em “Revisar agora” para voltar e alterar dados ou documentos.',
            },
            buttons: {
                now: 'Revisar agora',
                after: 'Ver depois',
            },
        },
    },
};
